import { useState, useEffect } from 'react';

export const useUserData = () => {
    const [userData, setUserData] = useState(null);
    const [typing, setTyping] = useState(false);
    const [status, setStatus] = useState('loading');

    useEffect(() => {
        const controller = new AbortController();

        const fetchUserData = async () => {
            try {
                const response = await fetch(`${process.env.PUBLIC_URL}/data/userData.json`, {
                    signal: controller.signal,
                });
                if (!response.ok) {
                    throw new Error(`Network response was not ok: ${response.status}`);
                }
                const data = await response.json();

                const profile = Array.isArray(data) ? data[0] : data;
                if (!profile) throw new Error('Portfolio data is empty.');

                // Skeleton loading delay set to 0.3s
                await new Promise((resolve) => setTimeout(resolve, 300));

                setUserData(profile);
                setStatus('ready');
            } catch (err) {
                if (err.name !== 'AbortError') {
                    console.error('Unable to load portfolio data:', err);
                    setStatus('error');
                }
            }
        };

        fetchUserData();

        const interval = setInterval(() => setTyping((prev) => !prev), 500);

        return () => {
            controller.abort();
            clearInterval(interval);
        };
    }, []);

    return { userData, typing, status };
};
